import * as moment from 'moment';
var DateTimeConverstionService = /** @class */ (function () {
    function DateTimeConverstionService() {
    }
    DateTimeConverstionService.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('MM/DD/YYYY hh:mm A');
        }
        else {
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('hh:mm A');
        }
    };
    return DateTimeConverstionService;
}());
export { DateTimeConverstionService };
//# sourceMappingURL=datetimeconverstion.service.js.map